import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, {
  init,
  payByCardToekn,
  payByCardId,
  queryResult,
  deleteCard,
  applePayValidateURL,
  payByDevice,
  completeDccPaymentIframe,
} from './modules'
import Loading from 'components/Loading'

export default function(route) {
  const PayPage = Loadable({
    loader: () => import('./PayPage'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          iframePayPageState: state.iframePayPageState,
          siteConfig: state.siteConfig,
        }),
        {
          init,
          payByCardToekn,
          payByCardId,
          queryResult,
          deleteCard,
          applePayValidateURL,
          payByDevice,
          completeDccPayment: completeDccPaymentIframe,
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={route.match.path}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <PayPage {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
